import React from 'react'

interface ErrorMessageProps {
  title: string
  message: string
  variant?: 'error' | 'warning' | 'info'
  className?: string
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  title,
  message,
  variant = 'error',
  className = '',
}) => {
  const variantClasses = {
    error: 'bg-red-500/10 border-red-400/30 text-red-300',
    warning: 'bg-yellow-500/10 border-yellow-400/30 text-yellow-300',
    info: 'bg-blue-500/10 border-blue-400/30 text-blue-300'
  }

  const iconClasses = {
    error: 'text-red-400',
    warning: 'text-yellow-400',
    info: 'text-blue-400'
  }

  return (
    <div className={`p-4 ${variantClasses[variant]} border rounded-lg backdrop-blur-sm ${className}`}>
      <div className="flex items-start space-x-2">
        <div className={`${iconClasses[variant]} mt-0.5`}>
          {variant === 'error' && '⚠️'}
          {variant === 'warning' && '⚠️'}
          {variant === 'info' && 'ℹ️'}
        </div>
        <div className="flex-1">
          <div className="font-medium text-sm">
            {title}
          </div>
          <div className="text-xs mt-1 opacity-80">
            {message}
          </div>
        </div>
      </div>
    </div>
  )
} 